import { Monitor } from "../types/Screen";
import { ScreenGroup } from "../types/ScreenGroup";

/**
 * Returns monitors that are not excluded and not already assigned
 * to any rename or group entry, optionally keeping a specific set
 * of screen IDs available (for the "current" group being edited).
 */
export const getAvailableScreens = (
	allScreens: Monitor[],
	excludedIds: number[],
	allRenames: ScreenGroup[],
	allGroups: ScreenGroup[],
	currentGroupScreenIds: number[] = [],
): Monitor[] => {
	const excludedSet = new Set(excludedIds);

	const assignedIds = new Set<number>();
	for (const entry of allRenames) {
		for (const id of entry.screen_ids) {
			assignedIds.add(id);
		}
	}
	for (const entry of allGroups) {
		for (const id of entry.screen_ids) {
			assignedIds.add(id);
		}
	}

	// Keep current group's own screens available so they stay visible
	for (const id of currentGroupScreenIds) {
		assignedIds.delete(id);
	}

	return allScreens.filter(
		(s) => !excludedSet.has(s.Monitor_ID) && !assignedIds.has(s.Monitor_ID),
	);
};
